 
import { Input } from "antd";
import type { SearchProps } from "antd/es/input/Search";
import { memo } from "react";
import SearchIcon from "../../assets/icons/search.svg";

export interface CustomSearchInputProps extends SearchProps {
  className?: string;
  value?: string;
  handleSearch?: (value: string) => void;
}

function CustomSearchInput({
  className = "",
  value = "",
  handleSearch = () => {},
  ...restParams
}: CustomSearchInputProps) {
  return (
    <div className="md:flex md:items-center">
      <div className="relative flex items-center w-full overflow-hidden bg-white rounded-lg md:w-48 md:ml-2 h-9">
        <Input.Search
          {...restParams}
          value={value}
          prefix={<SearchIcon className="text-xs" />}
          className={`custom-search-input ${className} border border-gray-250`}
          onChange={(e) => {
            handleSearch(e.target.value);
          }}
          enterButton={false}
        />
      </div>
    </div>
  );
}

export default memo(CustomSearchInput);
